import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GATrackingEventType } from '../../constants';

export class GATrackingPLPPaginationClickEvent implements GATrackingEvent {

  constructor(private pagination: { offset: number, limit: number }, private defaultLimit: number) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.PLPPaginationClick;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.PLPPagination,
      label: `page-number: ${ this.getPageNumber() }`
    };
  }

  private getPageNumber(): number {
    return this.pagination.offset / this.defaultLimit + 1;
  }
}
